import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, Tab, Stack, Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

export default function ViewTabs({ setIsOpen, can }) {
  const location = useLocation();
  const navigate = useNavigate();

  const canManageLookups =
    can("lookup:create") || can("lookup:edit") || can("lookup:delete");

  const views = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "List", path: "/list" },
    { label: "Board", path: "/board" },
    { label: "Timeline", path: "/timeline" },
    ...(can("initiative:view_activity")
      ? [{ label: "Activity", path: "/activity" }]
      : []),
    ...(canManageLookups ? [{ label: "Configure", path: "/configure" }] : []),
  ];

  const activePath = views.some((view) => view.path === location.pathname)
    ? location.pathname
    : false;

  const styles = {
    root: {
      px: 2,
      bgcolor: "background.tableHeader",
      borderBottom: 1,
      borderColor: "divider",
      display: "flex",
      justifyContent: "space-between",
    },
    nav: { minHeight: 40 },
    tab: {
      minHeight: 40,
      textTransform: "none",
      fontWeight: 500,
      color: "background.tableHeaderText",
      opacity: 0.7,
      "&.Mui-selected": { opacity: 1, fontWeight: 700 },
    },
    createBtn: {
      whiteSpace: "nowrap",
      flexShrink: 0,
      textTransform: "none",
      color: "background.tableHeaderText",
    },
    createBtnIcon: { position: "relative", top: -0.5 },
  };

  return (
    <Stack direction="row" sx={styles.root}>
      <Tabs
        value={activePath}
        textColor="inherit"
        indicatorColor="primary"
        sx={styles.nav}
      >
        {views.map((view) => (
          <Tab
            key={view.path}
            label={view.label}
            value={view.path}
            onClick={() => navigate(view.path)}
            sx={styles.tab}
          />
        ))}
      </Tabs>
      {can("initiative:create") && (
        <Button
          variant="text"
          size="small"
          startIcon={<AddIcon fontSize="small" sx={styles.createBtnIcon} />}
          onClick={setIsOpen}
          sx={styles.createBtn}
        >
          New Initiative
        </Button>
      )}
    </Stack>
  );
}
